module.exports = __webpack_public_path__ + "img/voting.38c619a1.svg";